import type { IntlShape } from 'react-intl';

export const formatFileSize = (fileSize: number, intl: IntlShape) => {
  const units = [
    intl.formatMessage({
      id: 'FormatFileSize.bytes',
      defaultMessage: 'B',
      description: 'Bytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.kilobytes',
      defaultMessage: 'KB',
      description: 'Kilobytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.megabytes',
      defaultMessage: 'MB',
      description: 'Megabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.gigabytes',
      defaultMessage: 'GB',
      description: 'Gigabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.terabytes',
      defaultMessage: 'TB',
      description: 'Terabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.petabytes',
      defaultMessage: 'PB',
      description: 'Petabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.exabytes',
      defaultMessage: 'EB',
      description: 'Exabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.zettabytes',
      defaultMessage: 'ZB',
      description: 'Zettabytes unit abbreviation',
    }),
    intl.formatMessage({
      id: 'FormatFileSize.yottabytes',
      defaultMessage: 'YB',
      description: 'Yottabytes unit abbreviation',
    }),
  ];
  const i = Math.floor(Math.log(fileSize) / Math.log(1024));
  const amount = Number((fileSize / Math.pow(1024, i)).toFixed(2));
  const unit = units[i];

  if (fileSize === 0) {
    return '-';
  }

  return `${amount}${unit}`;
};
